import { For, JSX } from "solid-js";
import { useDateWidget } from "../../../providers/dates/context";
import { EventCard } from "../EventCard";
import { Text } from "~/components/ui/text";

export function OncomingEventList(props: JSX.HTMLAttributes<HTMLElement>) {

	const { oncomingEvents } = useDateWidget();

	return (
		<aside {...props}>
			<div>
				<Text class="font-bold mb-7" size="md">
					Aankomende evenementen
				</Text>
				<div class="grid gap-y-6">
					<For each={oncomingEvents()}>
						{(event) => <EventCard event={event} showStartOnly />}
					</For>
				</div>
			</div>
		</aside>
	);
}